module.exports = __webpack_public_path__ + "static/media/85b06568.jpg";